
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index41UhiasNmtBU_X8oB8VQXkL_45K5Lgk3Khb1VXvehD4YoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/index.vue?macro=true";
import { default as loginohhd7z7mzAc_foxF5C1zWDsBmxWSdmXfu4eCaC0vxYEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/login.vue?macro=true";
import { default as mgenL4uEGf9V6BKMDFQjw5_45rBVnBLPnhgf7ZUfIvWa3UUiMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/mgen.vue?macro=true";
import { default as indexPOKjrLh_45M_4535flMoqPTCr3jGA4OxCSSgy6Dd2jAQK44Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/index.vue?macro=true";
import { default as noteskARm4VSXk_LPg0XJa3hxASBHGNfNGvyMyAggX1i6ZkoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/notes.vue?macro=true";
import { default as index3XtcBfkxdmUDS2rXEWGqrPjR0G_rbgO_ISfbto62RDsMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentQ9jCXWSypCbsv8OFxKtYXC5oZMzSbgfNNnDZCTg4etIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteaHM_T1VBAWrrrPBG2BMzYaF5epk0mTuSa2_XA0qQCqIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/plan-du-site.vue?macro=true";
import { default as edit4JSp5b8XcMoN97a91sKesQ4wqhvbqobW1lFZuyZcgssMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/edit.vue?macro=true";
import { default as placessuVqg_45y09KxmT3DcVWOO79LDE_LGaga74t_SGLRSKJcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/places.vue?macro=true";
import { default as accessibilitewbpa9P1TAwP3xSEYSVakJTAlD5426nw5Fj7q2kKbIfoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/accessibilite.vue?macro=true";
import { default as _91id_93xi9EPkO8GjGags_45m2_GXUvdcxo7fX6HOPakNIMxB0SQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/[id].vue?macro=true";
import { default as notificationsI870VA4aNtZvQqRfGjuo4fumgc_ngXGkZEq6_45_Nj4zQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/notifications.vue?macro=true";
import { default as indexZVyCIOB1fREKKuS5Tl5TCZLTWrjSIca8CQYJVB4azq8Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/index.vue?macro=true";
import { default as indexUJX_vp37Y8Y_45filLgpryAeXMOHzAmD_BDqO5GhiBJ4wMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/index.vue?macro=true";
import { default as _91slug_93Fj2ZX5qcg8dyxfdpzJmHPwqhq2trpEpb_45wM4q4w9FeEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/villes/[slug].vue?macro=true";
import { default as indexYWmKYql1EdR5dJim1jCKjzE6KgkBsZJ7xySrmhS__45_AMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/index.vue?macro=true";
import { default as generiqueKxHMYwZdbdpScRGm9yqnLkEmZanhsT91upyifF3o_45M8Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93GlOmmgvWIvVl0n3IUHuMs8qVpsuPldPHUClgY9KFkiAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/reseaux/[slug].vue?macro=true";
import { default as missionscg9tLBaeJA8nByjJFbnp7lV8x3isOmf6qJSPanrilFAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/missions.vue?macro=true";
import { default as index0krahZPqJ14ITGDkzUA8V4Z4oG7h_mH7FyVOGfJmV14Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/dashboard/index.vue?macro=true";
import { default as favorisJgWHXsi9wOVfq_LdpzNIWjjHn8A6G1HgXW3gT_452_45vd0Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93ouWFsRURslJ8LqfNCqCn1_45SH4Y_45olDJfqjjiWqTT2FAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/activites/[slug].vue?macro=true";
import { default as logsXxXTp9IzUEZrxXr2zvjmccKO7d_38QCKRazw_X49_45CMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/other/logs.vue?macro=true";
import { default as ressources82XADI0UiYth7mnxtLHQ2U7o_45rU96xd8YyY8_W1GXsQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legales5TxQJlhLFGYE2fqe73mONiRqqjsrfzuhPVNBkK0tvHkMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/mentions-legales.vue?macro=true";
import { default as missionsfTGNpzmX_t80_JGFB6ZqmF69kHYe72Y7mvbkDBStxvQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/missions.vue?macro=true";
import { default as settingsuSGptFV2Wjjv3ITfqo84qM2Li_45f8bhiiLEnAK_AE9XgMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/settings.vue?macro=true";
import { default as temoignageseT5Qj4Bkd9zH2MZAs_45oAggaX2APDnTx2NpKMTD2_a1EMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/temoignages.vue?macro=true";
import { default as indexy27VAPgeOO5Ccq_45uHHeTyvUVCxYreFwD73oGL14SSwMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/index.vue?macro=true";
import { default as admin_zgKgINZDlhgkaXYNIJU84MGXqcfALOzoEfP6faMdlkMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/maintenance/admin.vue?macro=true";
import { default as indexXRmXBZmJcfPVML_XrpQYZ4rJn6BzVF9T0ojkm5w_NLwMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/maintenance/index.vue?macro=true";
import { default as indexyOZHgCaT06kyVQfAYQuk1PiMaU4gicxnPu1Wbc_45QN8YMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/territoires/index.vue?macro=true";
import { default as _91hash_93cF4AjFAJrsQD_458f1aw_jdQw30ovUHalZWNpaPRey3MUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursXbj2_BAjDz3G670rcmwb0Lu446HHu1y0TIMYAtqE5GQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93TcEoikmA4nhrSn7YAmRlAhf09OBf9aEG7TkelgRNAjYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/associations/[slug].vue?macro=true";
import { default as _91slug_934IdFeoyUss9tu2p8CQfx56iHK9DjXowsy47LMZRRgoAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/departements/[slug].vue?macro=true";
import { default as index7c53uaoUP6YpsZnNdbR_B_45A0IXRths4mIsN2LlKlxAwMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/organisations/index.vue?macro=true";
import { default as preferencesKvKVTM1vq33rWvoLJPakjj8Vw3Tk65RvHRZvW1BcHqcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/preferences.vue?macro=true";
import { default as organisationsOANLlgQqq782Dm8YwssMXhnmVbO6Y_Mrz_45jMyMyZHSoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/organisations.vue?macro=true";
import { default as _91token_93Ojq8duvFDzL_45nh7lOGEaSUsEmROV3OEf1wqQ4PfOinEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/temoignages/[token].vue?macro=true";
import { default as postsTjhmgJXAa6cZ4c8X62p6b44dHTGHiEm4gRQrEwuW6V0Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/posts.vue?macro=true";
import { default as indexH0guggcGu0u_45JASRb5qc_454ygJ7wElrZaeiv4v4uOPEEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/index.vue?macro=true";
import { default as add9f0vvvl6_4531cAquts5MFfSw57HTzizJm87M1IkxHfrQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93WJH6IITJKh2CHdRMEs44YJAmjK_45AQg9bjrcmVp6WQ_sMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/organisations/[slug].vue?macro=true";
import { default as indexCyFxL1080mRv2qMMe7nQHi45lx4lYXcU6or3ZdfMUfsMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/password-reset/index.vue?macro=true";
import { default as participationsiQs2OC8ZKnfPY0N2vxEadyzfYQ4WiSnPvxX7Fi0TnXIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/participations.vue?macro=true";
import { default as emailsyW__9cQEAtPk0sW2bJgSGU5zBaWmK3XxPdKtvdHQp7AMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/emails.vue?macro=true";
import { default as indexONsP3aXVZPyeWL12sXsuwoINAHr5yXzIpsG66Q1QCI8Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsoEUy5i_45TvJVltYg_We_GyNdvI_tnumdO05cH8MyZzucMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/notifications.vue?macro=true";
import { default as indexbocsG30HSn7UX9N_452X5ENYtHAVyVYi1hg56z9t9gTTIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civique_45UBx1x0Cuoz2rDc_451A_45j_45HXKcWtm6fC_45vPwrugCJFioMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93q7sxmsozmi3ZR1zGtlIOx3CB4ylHH91q6qsy2K01amMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/domaines-action/[slug].vue?macro=true";
import { default as indexP7rzgip8ly_45mr_CtCoQOi1TclcPqVJy0ACSFyqMQfCkMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93KQn0cRSFcOWEsnUTNOmvGRFxjyisbOYz5D_45wav7JLRQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemble5LOD82RKEO1an4l2oL0vRUboiRcKqxo_454AZEy3ZCJeIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitations1qX1rfATFg5ioi4FHq_K7AR7Okyju7vx6JtXMxAQZZYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/other/invitations.vue?macro=true";
import { default as messagesN2M_45cZcUEhSPPuyf7qyn09sddV0bGlHMFkBJUZyuPVwMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/messages.vue?macro=true";
import { default as placesiKenKiwhNCIAkU4P3cvD9_Jodu6YuyYfMF96bFzPPFIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/places.vue?macro=true";
import { default as addKqOHiYWzhUR6fxu5dDx_nAb2gWqPpETa6pVsmnXVygUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/add.vue?macro=true";
import { default as index8ZJjves_luptQCM3yFQEDLD9Apkk0ikf9sdkuVJXjwcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexb1XRIgA8m4d5ow4pSp45zHQomVcuPEXP0wU8FyVBXiwMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/missions-benevolat/index.vue?macro=true";
import { default as datesREnW_45wn_x9IEQiUMWs5kHhCJgDDILWas4OF6t7bFIFwMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexf206AQjKMY0LcK4_NMxNuaksSNN_2q75GaGrG86LlEIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxX22tqkWSW0Vi91CXRSrn5TY7i2pA_cMDy3oNnOzDB_45oMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titlefeAs2Io3G149Gop7jdTUj7VYJvvnaDHM9SUYELktdusMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/title.vue?macro=true";
import { default as index_45c_7zyV49RB3__45pDRIpCHFkJkHlykNCjV_xbp8Uh_45Z8Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/index.vue?macro=true";
import { default as missionsnKX1tN2_45Q7hi_450Sn6M4fd3R2LfAWDu5QqhjDfLQg8X4Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/missions.vue?macro=true";
import { default as addRL6aWBkVtC4l8AW9qx58EAo7MrY_45AAAAtVS8BJtHx_45YMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelKwI9OXQtJb9EWY9iZAhJYc_45bD7gIxYma_FZf8Cga0icMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as index1op_dcRwFlxeV7KYZfPlZQveJ0CcLtmJwXj4y6joFm0Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/participations/index.vue?macro=true";
import { default as indexClrAI2IXY5q_45dwh6a1cFQvXdgzXpJPSoAO4qYcnQ2aMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexOcDaAmy7N6V6goiro7dFrsLkX9ba9JnRWSsPgXMum4UMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/index.vue?macro=true";
import { default as addHXuHh2NxsCF9HqLKswNVDkW3Pvh4YcdHg2sdaWtXscEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as add6UN_45GJvbQd2LN69S9lAb_5HaakE7MmlhtylU4_45yxNwYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addg6PDQTYzTlEJmdp7rmqOhxsLsCoaWTFA8t6UKZnUXgMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexBxGpXhfzm9YdmE9bMpicwhMcJ70jHKApTfMaXC_45E2voMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsOC691LJzeQDTq2RtPcSMH_45m81P6i3lOcBMVXaLH1zUcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/conversions.vue?macro=true";
import { default as editqf0F6hTBk224i_45c1WydNoNcOm3GUj5Z_455uRxA5b42LgMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteNbj6lb9JUKI53Gb4_45U7mR645pia4ODraNMZcBpDfytQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexLqWUqQm3jLxubwCEkahs5ByX7_mohenwaW5Y43l02d4Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as add2W1V0QcjDbnsBVZxD_d6LRq09GZ0vFMWHXmQs8_45UsSYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevoles2UE8Y9YR36zsiK7joSPBHGjeyxyAVU6_JE4ZWkTJuDQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editgFK5qDvLJy0zveZP2T85XmtHS6xfENGk3ZuA0Iq40TQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursc3lAtSF80o9I2el8y24YfVgXX_LthDFpDC4Q1RiTG4gMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexPEKsKdrhJXgWMRGnQggWP6kKxM18MI2ZJMKzJ5vzS_MMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as index_NfGMfwKTZkUelk2zzjFCgb04nQofBl1v2TdK8e19WYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexu0yONNx5r4hAqh846H5Kl0tac3e8wFCfTpYBfEBpZYYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/index.vue?macro=true";
import { default as indexmrGx0aQSkC6rpCi7Yd3FIiEejTJ5BtUT3GFnVb1HMbcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendrexLiGYQbwSoQ8BjXGG_45Sadi8a9gwwS_45Rs8OzoNthSTtUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexd1LroRYbkM0NXwLLsETwh7WVgyRXjUt4xCAZ6y9EBrIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addKFoVID_OxDZBPe1gEsNnrKMbpiqw1_3ijhhGOGpOFtMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexCz4eCvH96ArIhGRhYjpAXC6OUQ3q7eAo1BSbL_45wyWTwMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editpZtndtTKXwCKJwAlf2k_45z8gERT82ONwTX3sAqasLNioMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93g7xcFs9n8Qft72J72DWoEMLNnOky0qtu4YGaCPptOwoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteodMXNricS2NThYfPnYA1XsYnVowu1h7WvSNvuZR_45yIEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexqMjQe771QV4KQ_45UF7A7WeW2wlaIbCiXeL2feghXSEuYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationskDRlIS71MNY9_4540VDbC_45XOykCVQFdFAUzY8xN_45Dp56YMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/participations.vue?macro=true";
import { default as indexkNDj0XPTaY0zUUL_mSe9khJHwhQyPStJ2_45lUEtQqxJgMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsRRM0Jo96cJiNubZLy6YS8Qjkf4Xh5LLtBsf_WExS1h8Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/referents/activity-logs.vue?macro=true";
import { default as edit_7mZi2s6VceY_45LhR2dh4gr1yp64J8uy7YmIJ0NLJrCoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexODFMv54H36tkZjZmB93sNtQBtx4b80Oq_q24biMgBoYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsToZGHb9ngSkNBGxGiYkfu0zc_45ODHLMiPrZBUgFq3ZFQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsables0ZPu7WGXNpFvygf0gOgdpO9z6MYLgKMUnjkr3j3sYdoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editj7DCo2LPYw5WpV2iPyFasUEnrc9UnafK79_PM_o8nBoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexHrxuLrq_45dvCtgwqIYXuGjsRXYp5UzKcQcJqlmn_vMnUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexGv0HSwQkdW_45ZFPaMvBe9H_45xoulIz_gXHzH_9wefFMhsMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesDSJqdl3hovcOf9gb3poHntsUcD4n9oIGPbap_45C7GtqAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editZYvwJDXThmH1gdv4EcYEaF5WdT_45umhzqk5ahqlWHomEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profile9AEVa_45RbP2F9_u8pP9D9ucy_45rP_45pDPk0g6VaPe0OWIEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementG2UI4vmWWLcNjlOxN9tbc4xy6yp6OVKPSRL4QnKTLEkMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsgBGrbWcy7w4tjP_23k6FTLFB3DThujv6oea4vwOKNW0Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editYEfRNuw2XwLOasVKihxrxYa1XO_45_G4p_45x1RNyAXHqFoMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addImFvEo0JLLuAWNOxnCDNEN99f1SRxKkPwu2fI2XeltEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationtV68lkC8qnjnsaXILNmNOfcRHT3pzIRO6k5HLZAyZWYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexdZ9em1zHzrJTwSjFQz4R7Xt_45RNN49atKH_45RbLtfbmD4Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editQp6Xgu2dpfHVmr8HBCTFWg_45rOXazvOeUP5qgot_JO8IMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsh_Yem4vl_z7KUZBMvliJnCjqoO5GE_1kSxCEZ52KUCYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationssYPti8A_45mQDO91sk0m54XFsPKP8iFalzsdvFhRBNqqIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesy2_45z2MMCE4Df0JkdGSTc_45_45mrMwAQTN1zyWAbtEjpLVMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexing90Use8kRDUzmUX6z2lbDQJf8rV7C8K_nYVYh8saRmCcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexwlDQe5A1dSn1hkhD5f3I_455fxF2lygrtSF_02dBNHtsIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editMrnIDscGSni3l_45mac4nsNeYPsRz3_m2jEbxRvN6S9QcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexW5AJsyRPKkXcg04506YUbTxweiH3geIRNAOQiFqjBisMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileRb06ZXVN83Z_45I2iwrnaxEv6VQVoLtUBPcxzXeeXTWjYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexE8ak9Lcsx0Un3yAWNkn6HpLmtM2ToejVrRhJt49rvHkMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editJqXTJuK1fgRqU7riaXX9bcpDjR_45jYudMX25BOqZNcJMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addwmXkkwVboMtFEkOTCiEo3GKGD3EtDbJnOio4v7dRSfAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesyHA_45WUTOw9JTl2kvCWEUykV_45wJEEfywYFjLpgolyUXIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesIIFL0L7sVbNpaWYZkZ3XjUcIlC7t_45hnI0Rg9NyRHIGkMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersqDQ3IYDBmvAqeWrMEoOdlgrK1ku7ho0jg3tRp1OZep4Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresrCuH71lPIBzTtWbR1TnkwUpdGCESH8WAIJXVs4a9oZEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesqGYdQolGtIOjFdqIRX122dho9BgRluzXZMzoiHdVryAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisation1GLKUhuz038bq97YdrFfuryqHJhq7jhLoKdgzBZXWR0Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedJ3AqhKAYvpAclwT1jnVYnmo_EOTIlwPc5_45uhVus2r38Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsVwikGtofOEF2cmYPzeAkm7h_WDhtkfjk7R_45EA1P0FSQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45role69PDhYvDUKn0I17OjqjQL3ZrKKFt0qwyNngQy4apBSQMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsCRDTI558bLeOqTAou3syulOd3ynHBzFLWny2693lEtgMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editql_4594m0cUF9IdjB1vP9cUM7K5VyFaqt_aQRwfIZbhfYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesFTzyXADgImQJk6q53RDp_dzRSI4uBSFZp89UMG_TKdMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkWCJBvDTdo14w8Ij9XSSwoYZMT_45CjfRgtEPbXSGguAZUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexGuCp6S1DPvW9rhgExrCZxHgUno8QgFjPCaJiIEa9690Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivitelh5gKH2CmczldwItwoaP5N5pgrQDWmeXM7VQDElrD50Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationcwUhPNAHWiiudkQlNUXzVWUnTCa3u8aArgbB0u_9GSkMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsS_5wLXMboa8XnMcVV6fq772L93fLqD0EbcS4NCNHlSwMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantLREam1KT7LHTvTz0K_s1hjK8KBMLHNDYByyQR1k4CAUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortanttx9fLARIJSIX7LBk31wX6cn9EDURIFdpx_45Lm29cmpmMMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexy1XFYS6dGLZLuWM_45D3LwX4jvrENGkNRM7Ql_6_kv5BcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesXHCufB7JWU5z9P1FAUQCYmcfd1SjtRAlGaJgQm05bUUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerobvN3UC0HE9nrLJplfmY_45pGB12rtBeasKrtZyMVuJmAMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesBcBepmh683XZoEc_45A1wjuVON7nydLSCSq0INY9o4v9IMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesgy4VAMv4ZhoT91sf_y6nzKuPzlenTRX4_t4KxlSTZ9AMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsw_9g02Lv9s5LrVRIVJKahpWvthbaZAmSoYeG4N6XpkIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treated0GnxkmH00MLYWpoJzKVReGvNVdOzlVb_45z5LoMEH9vLIMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectwxHk4e9sgOK6XBQ3o3XLC8C4BN3NKAWMaK87PnlqPC8Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerT08oEaDDOXeImKau40JHnL0kezbcbJjyoFWndoPbDoEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementoDR8VfkMAHvh2YpQBV5RwQYp0EYmWwJGy0heOI16pt8Meta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationy7SeIzJEKmS23TSqnbnFQZpRpeXF7BsNT29J8d4q5gcMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationFIUdlAi_XzBzkZuxGHMqVld8OcPQoh5pi_41EetSxvYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerdnBTQblYETdVFkdZvMOonp8AulxDY89Z7ChtWNHr7GYMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesR_kG4t6pNC1KtoYD5uATR1b3AU__KyO1nPQVMU_VIiUMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta } from "/build/5212b599-801e-4301-b965-8576980bc6ae/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE } from "/build/5212b599-801e-4301-b965-8576980bc6ae/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginohhd7z7mzAc_foxF5C1zWDsBmxWSdmXfu4eCaC0vxYEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenL4uEGf9V6BKMDFQjw5_45rBVnBLPnhgf7ZUfIvWa3UUiMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexPOKjrLh_45M_4535flMoqPTCr3jGA4OxCSSgy6Dd2jAQK44Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: noteskARm4VSXk_LPg0XJa3hxASBHGNfNGvyMyAggX1i6ZkoMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: index3XtcBfkxdmUDS2rXEWGqrPjR0G_rbgO_ISfbto62RDsMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: edit4JSp5b8XcMoN97a91sKesQ4wqhvbqobW1lFZuyZcgssMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placessuVqg_45y09KxmT3DcVWOO79LDE_LGaga74t_SGLRSKJcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93xi9EPkO8GjGags_45m2_GXUvdcxo7fX6HOPakNIMxB0SQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsI870VA4aNtZvQqRfGjuo4fumgc_ngXGkZEq6_45_Nj4zQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexZVyCIOB1fREKKuS5Tl5TCZLTWrjSIca8CQYJVB4azq8Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexUJX_vp37Y8Y_45filLgpryAeXMOHzAmD_BDqO5GhiBJ4wMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexYWmKYql1EdR5dJim1jCKjzE6KgkBsZJ7xySrmhS__45_AMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueKxHMYwZdbdpScRGm9yqnLkEmZanhsT91upyifF3o_45M8Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93GlOmmgvWIvVl0n3IUHuMs8qVpsuPldPHUClgY9KFkiAMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionscg9tLBaeJA8nByjJFbnp7lV8x3isOmf6qJSPanrilFAMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index0krahZPqJ14ITGDkzUA8V4Z4oG7h_mH7FyVOGfJmV14Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisJgWHXsi9wOVfq_LdpzNIWjjHn8A6G1HgXW3gT_452_45vd0Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsXxXTp9IzUEZrxXr2zvjmccKO7d_38QCKRazw_X49_45CMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsfTGNpzmX_t80_JGFB6ZqmF69kHYe72Y7mvbkDBStxvQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsuSGptFV2Wjjv3ITfqo84qM2Li_45f8bhiiLEnAK_AE9XgMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/settings.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexy27VAPgeOO5Ccq_45uHHeTyvUVCxYreFwD73oGL14SSwMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: admin_zgKgINZDlhgkaXYNIJU84MGXqcfALOzoEfP6faMdlkMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexXRmXBZmJcfPVML_XrpQYZ4rJn6BzVF9T0ojkm5w_NLwMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93cF4AjFAJrsQD_458f1aw_jdQw30ovUHalZWNpaPRey3MUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursXbj2_BAjDz3G670rcmwb0Lu446HHu1y0TIMYAtqE5GQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesKvKVTM1vq33rWvoLJPakjj8Vw3Tk65RvHRZvW1BcHqcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsOANLlgQqq782Dm8YwssMXhnmVbO6Y_Mrz_45jMyMyZHSoMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93Ojq8duvFDzL_45nh7lOGEaSUsEmROV3OEf1wqQ4PfOinEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsTjhmgJXAa6cZ4c8X62p6b44dHTGHiEm4gRQrEwuW6V0Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexH0guggcGu0u_45JASRb5qc_454ygJ7wElrZaeiv4v4uOPEEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: add9f0vvvl6_4531cAquts5MFfSw57HTzizJm87M1IkxHfrQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93WJH6IITJKh2CHdRMEs44YJAmjK_45AQg9bjrcmVp6WQ_sMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexCyFxL1080mRv2qMMe7nQHi45lx4lYXcU6or3ZdfMUfsMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsiQs2OC8ZKnfPY0N2vxEadyzfYQ4WiSnPvxX7Fi0TnXIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsyW__9cQEAtPk0sW2bJgSGU5zBaWmK3XxPdKtvdHQp7AMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexONsP3aXVZPyeWL12sXsuwoINAHr5yXzIpsG66Q1QCI8Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsoEUy5i_45TvJVltYg_We_GyNdvI_tnumdO05cH8MyZzucMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexbocsG30HSn7UX9N_452X5ENYtHAVyVYi1hg56z9t9gTTIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexP7rzgip8ly_45mr_CtCoQOi1TclcPqVJy0ACSFyqMQfCkMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93KQn0cRSFcOWEsnUTNOmvGRFxjyisbOYz5D_45wav7JLRQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemble5LOD82RKEO1an4l2oL0vRUboiRcKqxo_454AZEy3ZCJeIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitations1qX1rfATFg5ioi4FHq_K7AR7Okyju7vx6JtXMxAQZZYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesN2M_45cZcUEhSPPuyf7qyn09sddV0bGlHMFkBJUZyuPVwMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesiKenKiwhNCIAkU4P3cvD9_Jodu6YuyYfMF96bFzPPFIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addKqOHiYWzhUR6fxu5dDx_nAb2gWqPpETa6pVsmnXVygUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: index8ZJjves_luptQCM3yFQEDLD9Apkk0ikf9sdkuVJXjwcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexb1XRIgA8m4d5ow4pSp45zHQomVcuPEXP0wU8FyVBXiwMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesREnW_45wn_x9IEQiUMWs5kHhCJgDDILWas4OF6t7bFIFwMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexf206AQjKMY0LcK4_NMxNuaksSNN_2q75GaGrG86LlEIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxX22tqkWSW0Vi91CXRSrn5TY7i2pA_cMDy3oNnOzDB_45oMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titlefeAs2Io3G149Gop7jdTUj7VYJvvnaDHM9SUYELktdusMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: index_45c_7zyV49RB3__45pDRIpCHFkJkHlykNCjV_xbp8Uh_45Z8Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsnKX1tN2_45Q7hi_450Sn6M4fd3R2LfAWDu5QqhjDfLQg8X4Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addRL6aWBkVtC4l8AW9qx58EAo7MrY_45AAAAtVS8BJtHx_45YMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelKwI9OXQtJb9EWY9iZAhJYc_45bD7gIxYma_FZf8Cga0icMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: index1op_dcRwFlxeV7KYZfPlZQveJ0CcLtmJwXj4y6joFm0Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexClrAI2IXY5q_45dwh6a1cFQvXdgzXpJPSoAO4qYcnQ2aMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexOcDaAmy7N6V6goiro7dFrsLkX9ba9JnRWSsPgXMum4UMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addHXuHh2NxsCF9HqLKswNVDkW3Pvh4YcdHg2sdaWtXscEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: add6UN_45GJvbQd2LN69S9lAb_5HaakE7MmlhtylU4_45yxNwYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addg6PDQTYzTlEJmdp7rmqOhxsLsCoaWTFA8t6UKZnUXgMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexBxGpXhfzm9YdmE9bMpicwhMcJ70jHKApTfMaXC_45E2voMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsOC691LJzeQDTq2RtPcSMH_45m81P6i3lOcBMVXaLH1zUcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editqf0F6hTBk224i_45c1WydNoNcOm3GUj5Z_455uRxA5b42LgMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexLqWUqQm3jLxubwCEkahs5ByX7_mohenwaW5Y43l02d4Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: add2W1V0QcjDbnsBVZxD_d6LRq09GZ0vFMWHXmQs8_45UsSYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevoles2UE8Y9YR36zsiK7joSPBHGjeyxyAVU6_JE4ZWkTJuDQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editgFK5qDvLJy0zveZP2T85XmtHS6xfENGk3ZuA0Iq40TQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursc3lAtSF80o9I2el8y24YfVgXX_LthDFpDC4Q1RiTG4gMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexPEKsKdrhJXgWMRGnQggWP6kKxM18MI2ZJMKzJ5vzS_MMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: index_NfGMfwKTZkUelk2zzjFCgb04nQofBl1v2TdK8e19WYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrexLiGYQbwSoQ8BjXGG_45Sadi8a9gwwS_45Rs8OzoNthSTtUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexd1LroRYbkM0NXwLLsETwh7WVgyRXjUt4xCAZ6y9EBrIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addKFoVID_OxDZBPe1gEsNnrKMbpiqw1_3ijhhGOGpOFtMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexCz4eCvH96ArIhGRhYjpAXC6OUQ3q7eAo1BSbL_45wyWTwMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editpZtndtTKXwCKJwAlf2k_45z8gERT82ONwTX3sAqasLNioMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteodMXNricS2NThYfPnYA1XsYnVowu1h7WvSNvuZR_45yIEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexqMjQe771QV4KQ_45UF7A7WeW2wlaIbCiXeL2feghXSEuYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationskDRlIS71MNY9_4540VDbC_45XOykCVQFdFAUzY8xN_45Dp56YMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsRRM0Jo96cJiNubZLy6YS8Qjkf4Xh5LLtBsf_WExS1h8Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: edit_7mZi2s6VceY_45LhR2dh4gr1yp64J8uy7YmIJ0NLJrCoMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexODFMv54H36tkZjZmB93sNtQBtx4b80Oq_q24biMgBoYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsToZGHb9ngSkNBGxGiYkfu0zc_45ODHLMiPrZBUgFq3ZFQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsables0ZPu7WGXNpFvygf0gOgdpO9z6MYLgKMUnjkr3j3sYdoMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editj7DCo2LPYw5WpV2iPyFasUEnrc9UnafK79_PM_o8nBoMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexHrxuLrq_45dvCtgwqIYXuGjsRXYp5UzKcQcJqlmn_vMnUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexGv0HSwQkdW_45ZFPaMvBe9H_45xoulIz_gXHzH_9wefFMhsMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesDSJqdl3hovcOf9gb3poHntsUcD4n9oIGPbap_45C7GtqAMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editZYvwJDXThmH1gdv4EcYEaF5WdT_45umhzqk5ahqlWHomEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profile9AEVa_45RbP2F9_u8pP9D9ucy_45rP_45pDPk0g6VaPe0OWIEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsgBGrbWcy7w4tjP_23k6FTLFB3DThujv6oea4vwOKNW0Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editYEfRNuw2XwLOasVKihxrxYa1XO_45_G4p_45x1RNyAXHqFoMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addImFvEo0JLLuAWNOxnCDNEN99f1SRxKkPwu2fI2XeltEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexdZ9em1zHzrJTwSjFQz4R7Xt_45RNN49atKH_45RbLtfbmD4Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editQp6Xgu2dpfHVmr8HBCTFWg_45rOXazvOeUP5qgot_JO8IMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsh_Yem4vl_z7KUZBMvliJnCjqoO5GE_1kSxCEZ52KUCYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationssYPti8A_45mQDO91sk0m54XFsPKP8iFalzsdvFhRBNqqIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexing90Use8kRDUzmUX6z2lbDQJf8rV7C8K_nYVYh8saRmCcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexwlDQe5A1dSn1hkhD5f3I_455fxF2lygrtSF_02dBNHtsIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editMrnIDscGSni3l_45mac4nsNeYPsRz3_m2jEbxRvN6S9QcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexW5AJsyRPKkXcg04506YUbTxweiH3geIRNAOQiFqjBisMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileRb06ZXVN83Z_45I2iwrnaxEv6VQVoLtUBPcxzXeeXTWjYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexE8ak9Lcsx0Un3yAWNkn6HpLmtM2ToejVrRhJt49rvHkMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editJqXTJuK1fgRqU7riaXX9bcpDjR_45jYudMX25BOqZNcJMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addwmXkkwVboMtFEkOTCiEo3GKGD3EtDbJnOio4v7dRSfAMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesyHA_45WUTOw9JTl2kvCWEUykV_45wJEEfywYFjLpgolyUXIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesIIFL0L7sVbNpaWYZkZ3XjUcIlC7t_45hnI0Rg9NyRHIGkMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersqDQ3IYDBmvAqeWrMEoOdlgrK1ku7ho0jg3tRp1OZep4Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresrCuH71lPIBzTtWbR1TnkwUpdGCESH8WAIJXVs4a9oZEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisation1GLKUhuz038bq97YdrFfuryqHJhq7jhLoKdgzBZXWR0Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedJ3AqhKAYvpAclwT1jnVYnmo_EOTIlwPc5_45uhVus2r38Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsVwikGtofOEF2cmYPzeAkm7h_WDhtkfjk7R_45EA1P0FSQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45role69PDhYvDUKn0I17OjqjQL3ZrKKFt0qwyNngQy4apBSQMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsCRDTI558bLeOqTAou3syulOd3ynHBzFLWny2693lEtgMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editql_4594m0cUF9IdjB1vP9cUM7K5VyFaqt_aQRwfIZbhfYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesFTzyXADgImQJk6q53RDp_dzRSI4uBSFZp89UMG_TKdMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkWCJBvDTdo14w8Ij9XSSwoYZMT_45CjfRgtEPbXSGguAZUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexGuCp6S1DPvW9rhgExrCZxHgUno8QgFjPCaJiIEa9690Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivitelh5gKH2CmczldwItwoaP5N5pgrQDWmeXM7VQDElrD50Meta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationcwUhPNAHWiiudkQlNUXzVWUnTCa3u8aArgbB0u_9GSkMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsS_5wLXMboa8XnMcVV6fq772L93fLqD0EbcS4NCNHlSwMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantLREam1KT7LHTvTz0K_s1hjK8KBMLHNDYByyQR1k4CAUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortanttx9fLARIJSIX7LBk31wX6cn9EDURIFdpx_45Lm29cmpmMMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexy1XFYS6dGLZLuWM_45D3LwX4jvrENGkNRM7Ql_6_kv5BcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesXHCufB7JWU5z9P1FAUQCYmcfd1SjtRAlGaJgQm05bUUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerobvN3UC0HE9nrLJplfmY_45pGB12rtBeasKrtZyMVuJmAMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesBcBepmh683XZoEc_45A1wjuVON7nydLSCSq0INY9o4v9IMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesgy4VAMv4ZhoT91sf_y6nzKuPzlenTRX4_t4KxlSTZ9AMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsw_9g02Lv9s5LrVRIVJKahpWvthbaZAmSoYeG4N6XpkIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treated0GnxkmH00MLYWpoJzKVReGvNVdOzlVb_45z5LoMEH9vLIMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerT08oEaDDOXeImKau40JHnL0kezbcbJjyoFWndoPbDoEMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationy7SeIzJEKmS23TSqnbnFQZpRpeXF7BsNT29J8d4q5gcMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationFIUdlAi_XzBzkZuxGHMqVld8OcPQoh5pi_41EetSxvYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerdnBTQblYETdVFkdZvMOonp8AulxDY89Z7ChtWNHr7GYMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesR_kG4t6pNC1KtoYD5uATR1b3AU__KyO1nPQVMU_VIiUMeta || {},
    component: () => import("/build/5212b599-801e-4301-b965-8576980bc6ae/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/user/settings",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/statistiques",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  },
  {
    name: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubaMOsGS4tvIWViml83dDBuh_z5FGh4jwf2zEVCDvbuVE
  }
]